import api from "./apiClient";
import API_ENDPOINTS from "../config/apiEndpoints";
import {
  ipValueFromRow,
  isValidIpv4,
  parseAllowlistEntryToRow,
} from "./organizationLoginIpService";

export {
  ipValueFromRow,
  isValidIpv4,
  parseAllowlistEntryToRow,
  buildAllowlistRemoveSuccessMessage,
  isGenericAllowlistApiMessage,
} from "./organizationLoginIpService";

const getSetupFromPayload = (payload) => {
  if (!payload || typeof payload !== "object") {
    return {
      isProfileSystemAdministrator: false,
      organizationEntries: [],
      staffEntries: [],
    };
  }
  const organizationEntries = Array.isArray(payload.OrganizationEntries)
    ? payload.OrganizationEntries
    : Array.isArray(payload.organizationEntries)
      ? payload.organizationEntries
      : [];
  const staffEntries = Array.isArray(payload.StaffEntries)
    ? payload.StaffEntries
    : Array.isArray(payload.staffEntries)
      ? payload.staffEntries
      : [];
  return {
    isProfileSystemAdministrator: Boolean(
      payload.IsProfileSystemAdministrator ?? payload.isProfileSystemAdministrator,
    ),
    organizationEntries,
    staffEntries,
  };
};

export const fetchStaffLoginIpSetup = async (organizationId, staffId) => {
  const query = new URLSearchParams({
    organizationId: organizationId || "",
    staffId: staffId || "",
  });
  return api.get(`${API_ENDPOINTS.ORG_SECURITY.GET_STAFF_LOGIN_IPS}?${query.toString()}`);
};

export const parseStaffLoginIpSetup = (response) => {
  if (Number(response?.success) !== 1) {
    return {
      ok: false,
      message: response?.message || "Could not load networking settings.",
      isProfileSystemAdministrator: false,
      organizationEntries: [],
      staffEntries: [],
    };
  }
  const parsed = getSetupFromPayload(response.data);
  return { ok: true, message: "", ...parsed };
};

export const addStaffLoginIp = async (payload) => {
  return api.post(API_ENDPOINTS.ORG_SECURITY.STAFF_LOGIN_IP_ACTIVITY, {
    ActionType: "Add",
    ...payload,
  });
};

export const removeStaffLoginIp = async (payload) => {
  return api.post(API_ENDPOINTS.ORG_SECURITY.STAFF_LOGIN_IP_ACTIVITY, {
    ActionType: "Remove",
    ...payload,
  });
};

export const getStaffEntriesFromPayload = (payload) => {
  const parsed = getSetupFromPayload(payload);
  return parsed.staffEntries;
};

export default {
  fetchStaffLoginIpSetup,
  parseStaffLoginIpSetup,
  addStaffLoginIp,
  removeStaffLoginIp,
  getStaffEntriesFromPayload,
};
